import { createFileRoute } from '@tanstack/react-router';

import { AssetsPage } from '../features/a2v/assets/AssetsPage';
import { assetsRouteSearchSchema } from '../features/a2v/assets/assetsRouteSearch';

export const Route = createFileRoute('/a2v/assets')({
  validateSearch: assetsRouteSearchSchema,
  component: AssetsPage,
});
